import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReservationService } from '@app/reservation/reservation.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-voucher-manager',
  templateUrl: './voucher-manager.component.html',
  styleUrls: ['./voucher-manager.component.scss']
})
export class VoucherManagerComponent {
  @Input() ticketPrice: any = 0;
  @Input() clientId: number;

  @Output() voucherChanges = new EventEmitter<{ vouchers: any; finalPrice: any }>();

  enteredVoucher: string = '';
  appliedVouchers: any[] = [];
  voucherError: string = '';

  constructor(private reservationService: ReservationService, private translateService: TranslateService) {}

  checkVoucher() {
    const currentFinalPrice = this.calculateFinalPrice();

    if (currentFinalPrice <= 0) {
      this.voucherError = 'Total already covered by vouchers.';
      return;
    }

    this.reservationService.checkVoucher(this.clientId, this.enteredVoucher).subscribe(
      res => {
        this.voucherError = '';

        if (this.appliedVouchers.find(v => v.code === res.code)) {
          this.voucherError = 'Voucher already applied.';
          this.enteredVoucher = '';
          return;
        }

        const applicableValue = Math.min(res.residualValue, currentFinalPrice);
        if (applicableValue <= 0) {
          this.voucherError = 'This voucher cannot be applied as total is already covered.';
          this.enteredVoucher = '';
          return;
        }

        this.appliedVouchers.push(res);
        this.emitChanges();
        this.enteredVoucher = '';
      },
      error => {
        this.voucherError = error.error.msg || this.translateService.instant('widget.reservation.voucherCodeInvalid');
      }
    );
  }

  removeVoucher(code: string) {
    this.appliedVouchers = this.appliedVouchers.filter(v => v.code !== code);
    this.emitChanges();
  }

  // emitChanges() {
  //   let remainingPrice = this.ticketPrice;
  //   let totalVoucherValue = 0;

  //   const updatedVouchers = this.appliedVouchers.map(voucher => {
  //     const applicableValue = Math.min(voucher.residualValue, remainingPrice);
  //     totalVoucherValue += applicableValue;
  //     remainingPrice -= applicableValue;
  //     return { ...voucher, voucherValue: applicableValue };
  //   });

  //   this.appliedVouchers = [...updatedVouchers];
  //   const finalPrice = Math.max(remainingPrice, 0);
  //   this.voucherChanges.emit({
  //     vouchers: { appliedVouchers: updatedVouchers, totalVoucherValue },
  //     finalPrice
  //   });
  // }

  emitChanges() {
    let remainingPrice = this.round(this.ticketPrice);
    let totalVoucherValue = 0;

    const updatedVouchers = this.appliedVouchers.map(voucher => {
      const applicableValue = Math.min(this.round(voucher.residualValue), remainingPrice);

      totalVoucherValue = this.round(totalVoucherValue + applicableValue);
      remainingPrice = this.round(remainingPrice - applicableValue);

      return { ...voucher, voucherValue: applicableValue };
    });

    this.appliedVouchers = [...updatedVouchers];

    const finalPrice = Math.max(this.round(remainingPrice), 0);

    this.voucherChanges.emit({
      vouchers: { appliedVouchers: updatedVouchers, totalVoucherValue },
      finalPrice
    });
  }

  round(value: number): number {
    return Math.round(value * 100) / 100;
  }

  private calculateFinalPrice(): any {
    let remainingPrice = this.ticketPrice;

    this.appliedVouchers.forEach(voucher => {
      const applicableValue = Math.min(voucher.residualValue, remainingPrice);
      remainingPrice -= applicableValue;
    });

    return Math.max(remainingPrice, 0);
  }
}
